module.exports = {"title":"Diário de viagem da Contributopia","read":"Ler o diário de viagem do Contributopia","title2":"Diário de viagem"};